import { useTranslation } from 'react-i18next';
import { Dialog, IconButton, Stack, styled, Text } from 'shell/components';

const FailedGenerationDialog = ({ open, onClose }) => {
    const { t } = useTranslation('assignment');

    return (
        <CustomDialog open={open} onClose={onClose}>
            <Stack spacing={4}>
                <Stack alignItems={'flex-start'} direction={'row'} justifyContent={'space-between'} spacing={4}>
                    <Text variant={'h6'} weight={'semibold'}>
                        {t(
                            'dialog.generation-failed.title',
                            'Why weren’t grades/feedback generated for this assignment?'
                        )}
                    </Text>
                    <IconButton kind={'exit'} size={'medium'} variant={'square'} onClick={onClose} />
                </Stack>
                <Text>
                    {t(
                        'dialog.generation-failed.description',
                        'Automated grading/feedback suggestions cannot be generated for certain assignments due to reasons such as unrecognized formatting, technical errors, or incomplete information. To ensure accurate assessment, instructors will need to grade these assignments manually.'
                    )}
                </Text>
            </Stack>
        </CustomDialog>
    );
};

const CustomDialog = styled(Dialog)(() => {
    return {
        '& .MuiDialog-paper': {
            width: '440px',
        },
    };
});

export default FailedGenerationDialog;
